import $ from 'jquery'
// helpers
const body = document.querySelector('body')
const header = document.querySelector('.header')
const modals = document.querySelectorAll('.modal')
const btns = document.querySelectorAll('.header__icon')
let lastIcon


// set the top and height properties of any modal and toggle the body scroll
const modalHandler = (currentModal, btn) => {

  const alreadyActive = document.querySelector('.modal--active')
  const wpadminbar = document.getElementById('wpadminbar')
  lastIcon = btn

  if (!(body.classList.contains('no-scroll') && currentModal !== alreadyActive)) {
    body.classList.toggle('no-scroll')
  }


  let headerHeight = (wpadminbar ? wpadminbar.offsetHeight : 0) + 'px'

  modals.forEach(modal => {

    modal.style.top = headerHeight
    modal.style.height = `calc( 100vh - ${headerHeight} )`;
    if (currentModal !== modal) {
      modal.classList.remove('modal--active')
    }
  })
  btns.forEach(b => {

    if (btn !== b) {
      b.classList.remove('btn--active')
    }
  })

  currentModal.classList.toggle('modal--active')
  btn.classList.toggle('btn--active')


  closeModal(btn)


  // move focus to actiev modal
  const a = currentModal.querySelector('a')
  const input = currentModal.querySelector('input:not([type="hidden"]):not([type="search"])')//(don't focus on search input)

  if (input) {
    setTimeout(() => input.focus(), 90)
  } else if (a) {
    setTimeout(() => a.focus(), 90)
  }
}

// header menu
export const headerMenu = () => {

  const btn = document.querySelector('.header-menu-icon')
  const modal = document.querySelector('.modal--header-menu')

  btn.addEventListener('click', e => modalHandler(modal, btn))

}

// quick access
export const quickAccess = () => {

  const btn = document.querySelector('.quick-access-icon')
  const modal = document.querySelector('.modal--quick-access')

  btn.addEventListener('click', e => modalHandler(modal, btn))
}

// log in
export const logIn = () => {

  const btn = document.querySelector('.login-icon')
  const modal = document.querySelector('.modal--login')

  btn.addEventListener('click', e => {
    modalHandler(modal, btn)
  })

}

// header contact
export const headerContact = () => {


  const btn = document.querySelector('.contact-icon')
  const modal = document.querySelector('.modal--header-contact')

  btn.addEventListener('click', e => {
    modalHandler(modal, btn)
  })
}


//
const closeModal = (btn, escKey = null) => {
  const activeModal = document.querySelector('.modal--active')
  // const modalInner = document.querySelector('.modal--active')
  const closeMobalBtn = document.querySelector('.modal--active .modal__close')

  activeModal && activeModal.addEventListener('click', function (e) {
    if (e.target.classList.contains('modal')) {
      activeModal.classList.remove('modal--active')
      btn.classList.remove('btn--active')
      body.classList.remove('no-scroll')
      returnFocus()
    }

  })

  closeMobalBtn && closeMobalBtn.addEventListener('click', function (e) {
    activeModal.classList.remove('modal--active')
    btn.classList.remove('btn--active')
    body.classList.remove('no-scroll')
    returnFocus()
  })
}

document.addEventListener('keyup', e => {

  // Enter Space and Esc
  if (e.keyCode !== 13 && e.keyCode !== 27)
    return


  const { activeElement } = document

  // close active modal when esc pressed
  if (e.keyCode === 27) {
    const activeModal = document.querySelector('.modal--active')
    if (activeModal) {
      activeModal.classList.remove('modal--active')
      body.classList.remove('no-scroll')
      returnFocus()
    }

    return
  }

  // close active modal when enter or space beeing pressed and the focus is on the close btn 
  if (document.activeElement === document.querySelector('.modal--active .modal__close') && e.keyCode === 13) {

    const activeModal = document.querySelector('.modal--active')

    if (activeModal) {
      activeModal.classList.remove('modal--active')
      body.classList.remove('no-scroll')
      returnFocus()
    }

    return

  }

  if ((document.querySelector('.contact-icon') !== activeElement) &&
    (document.querySelector('.quick-access-icon') !== activeElement) &&
    (document.querySelector('.login-icon') !== activeElement)) {
    return
  }

  if (document.querySelector('.contact-icon') === activeElement) {
    modalHandler(document.querySelector('.modal--header-contact'), activeElement)
  } else if (document.querySelector('.quick-access-icon') === activeElement) {
    modalHandler(document.querySelector('.modal--quick-access'), activeElement)
  } else if (document.querySelector('.login-icon') === activeElement) {
    modalHandler(document.querySelector('.modal--login'), activeElement)
  }

})

function returnFocus() {
  lastIcon.focus()
  lastIcon.classList.remove('btn--active')
}

const forgot = document.getElementById('forgot-pass')
forgot.addEventListener('click', e => {
  e.preventDefault()
  document.getElementById('login-form-wrapper').innerHTML = `
  <span class="modal__close" aria-label="סגור" tabindex="0">×</span>
  <h2 class="section__title center-text login__title">שכחתי סיסמה</h2>
  <form id="forgot-form" class="login__form">
    <input class="login__input" type="text" name="IDNumber" placeholder="תעודת זהות" required aria-label="תעודת זהות">
    <input class="login__input" type="email" name="Email" placeholder='כתובת דוא״ל'  required aria-label='כתובת דוא״ל'>
    <button class="login__input login__input--submit" type="submit">שליחה</button>
  </form>
  <a href="/" class="login__action"><span>חזרה</span></a>`
  const form = document.getElementById('forgot-form')
  form.addEventListener('submit', event => {
    event.preventDefault()
    const fields = {}
    form.querySelectorAll('input').forEach(field => {
      fields[field['name']] = field.value
    })
    console.log('Data Sent:', fields)

    $.ajax({
      dataType: "json",
      url: '//api.bat-ami.org.il/api/Account/PasswordRecovery',
      type: 'POST',
      xhrFields: {
        withCredentials: true
      },
      headers: {
        'Accept': 'application/json',
        //'Content-Type': 'application/json',
        //'Cache': 'no-cache',
      },
      data: fields,
      success: function (res) {
        console.log(res)
        let html = `
              <h4>הסיסמה תישלח אליך בהקדם</h4>
              <a href=${window.location.href}>להמשך גלישה באתר</a>`

        form.innerHTML = html
      },
      error: function (xhr, text, err) {
        console.log('xhr:', xhr)
        console.log('err', err)
        form.innerHTML = `<h3>אחד או שני הפרטים אינם נכונים<h3>`
      }
    })
  })
})
